export const getFooterHeight = (): number => {
  const element: Element = document.getElementById("mut-footer");
  if (!!element) {
    return element.clientHeight;
  }
  return 0;
};
